<div class="home-container">
  <!-- Header -->
  <header class="page-header">
    <div class="search-bar">
      <svg class="search-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <circle cx="9" cy="9" r="7" stroke="currentColor" stroke-width="2"/>
        <path d="M14 14L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      <input type="text" placeholder="Search here ..." class="search-input">
    </div>
    
    <div class="user-profile">
      <div class="user-avatar">
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <circle cx="20" cy="20" r="20" fill="#0e40d8"/>
          <circle cx="20" cy="16" r="6" fill="white"/>
          <path d="M10 32C10 26.4772 14.4772 22 20 22C25.5228 22 30 26.4772 30 32" stroke="white" stroke-width="2"/>
        </svg>
      </div>
      <div class="user-info">
        <span class="user-name">{{ currentUser()?.nombre || 'Usuario' }} {{ currentUser()?.apellido || '' }}</span>
        <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
          <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </div>
    </div>
  </header>

  <!-- Live Events Banner: Solo se muestra si hay eventos en vivo -->
  @if (liveEvents().length > 0) {
    <section class="live-events-section">
      <div class="live-events-header">
        <div class="header-content">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" class="live-icon">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
            <circle cx="12" cy="12" r="3" fill="#DC3D1A"/>
          </svg>
          <h2 class="live-events-title">Eventos en Vivo</h2>
          <span class="live-badge">
            <span class="live-dot"></span>
            {{ liveEvents().length }} en vivo ahora
          </span>
        </div>
        <a href="#" class="view-all-link">Ver todos</a>
      </div>

      <div class="live-carousel-wrapper">
        <!-- Botón Anterior -->
        @if (canScrollPrev()) {
          <button 
            class="carousel-nav carousel-prev" 
            (click)="scrollLiveEvents('prev')"
            aria-label="Evento anterior">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        }

        <!-- Carrusel de eventos -->
        <div 
          #liveCarousel 
          class="live-events-carousel" 
          (scroll)="onCarouselScroll()">
          @for (event of liveEvents(); track event.id) {
            <article class="live-event-card" [style.border-left-color]="event.color">
              <div class="event-thumbnail">
                <img [src]="event.thumbnail" [alt]="event.instructor" class="instructor-photo">
                <div class="thumbnail-overlay" [style.background]="'linear-gradient(to bottom, transparent, ' + event.color + '40)'"></div>
                <div class="live-indicator">
                  <span class="pulse-dot"></span>
                  <span class="live-text">EN VIVO</span>
                </div>
              </div>
              
              <div class="event-content">
                <div class="event-category">{{ event.category }}</div>
                <h3 class="event-title">{{ event.title }}</h3>
                <div class="event-instructor">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <circle cx="8" cy="6" r="3" stroke="currentColor" stroke-width="1.5"/>
                    <path d="M2 14C2 11.7909 4.68629 10 8 10C11.3137 10 14 11.7909 14 14" stroke="currentColor" stroke-width="1.5"/>
                  </svg>
                  <span>{{ event.instructor }}</span>
                </div>
                
                <div class="event-footer">
                  <div class="event-stats">
                    <div class="stat">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M8 2C4.7 2 2 4.7 2 8C2 11.3 4.7 14 8 14C11.3 14 14 11.3 14 8C14 4.7 11.3 2 8 2ZM8 12.5C5.5 12.5 3.5 10.5 3.5 8C3.5 5.5 5.5 3.5 8 3.5C10.5 3.5 12.5 5.5 12.5 8C12.5 10.5 10.5 12.5 8 12.5Z" fill="currentColor"/>
                        <path d="M8.5 5H7.5V8.5H11V7.5H8.5V5Z" fill="currentColor"/>
                      </svg>
                      <span>{{ event.duration }}</span>
                    </div>
                    <div class="stat participants">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M11 7C12.1046 7 13 6.10457 13 5C13 3.89543 12.1046 3 11 3C9.89543 3 9 3.89543 9 5C9 6.10457 9.89543 7 11 7Z" stroke="currentColor" stroke-width="1.5"/>
                        <path d="M5 7C6.10457 7 7 6.10457 7 5C7 3.89543 6.10457 3 5 3C3.89543 3 3 3.89543 3 5C3 6.10457 3.89543 7 5 7Z" stroke="currentColor" stroke-width="1.5"/>
                        <path d="M8 9C9.10457 9 10 8.10457 10 7C10 5.89543 9.10457 5 8 5C6.89543 5 6 5.89543 6 7C6 8.10457 6.89543 9 8 9Z" stroke="currentColor" stroke-width="1.5"/>
                        <path d="M11 8C12.1046 8 13 8.89543 13 10V12H9V10C9 8.89543 9.89543 8 11 8Z" stroke="currentColor" stroke-width="1.5"/>
                        <path d="M5 8C6.10457 8 7 8.89543 7 10V12H3V10C3 8.89543 3.89543 8 5 8Z" stroke="currentColor" stroke-width="1.5"/>
                        <path d="M8 10C9.10457 10 10 10.8954 10 12V14H6V12C6 10.8954 6.89543 10 8 10Z" stroke="currentColor" stroke-width="1.5"/>
                      </svg>
                      <span>{{ event.participants }}</span>
                    </div>
                  </div>
                  
                  <button class="btn-join-live" (click)="joinLiveEvent(event.id)">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M3 2L13 8L3 14V2Z" fill="currentColor"/>
                    </svg>
                    Unirse ahora
                  </button>
                </div>
              </div>
            </article>
          }
        </div>

        <!-- Botón Siguiente -->
        @if (canScrollNext()) {
          <button 
            class="carousel-nav carousel-next" 
            (click)="scrollLiveEvents('next')"
            aria-label="Evento siguiente">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        }
      </div>
    </section>
  }

  <!-- Main Content -->
  <div class="content-wrapper">
    <!-- Left Section - Courses -->
    <section class="courses-section">
      <div class="section-header">
        <h1 class="section-title">My Courses</h1>
      </div>

      <!-- Filters -->
      <div class="filters">
        @for (filter of filters; track filter) {
          <button 
            class="filter-btn" 
            [class.active]="activeFilter() === filter"
            (click)="setFilter(filter)">
            @if (filter === 'Upcoming') {
              <span class="filter-dot"></span>
            }
            {{ filter }}
          </button>
        }
      </div>

      <!-- Courses List -->
      @if (isLoading()) {
        <div class="loading-container">
          <div class="spinner-large"></div>
          <p class="loading-text">Cargando tus cursos...</p>
        </div>
      } @else if (courses().length === 0) {
        <div class="empty-state">
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
            <circle cx="40" cy="40" r="40" fill="rgba(14, 64, 216, 0.1)"/>
            <path d="M40 20C28.96 20 20 28.96 20 40C20 51.04 28.96 60 40 60C51.04 60 60 51.04 60 40C60 28.96 51.04 20 40 20ZM40 55C31.72 55 25 48.28 25 40C25 31.72 31.72 25 40 25C48.28 25 55 31.72 55 40C55 48.28 48.28 55 40 55Z" fill="#0e40d8"/>
          </svg>
          <h3>No tienes cursos inscritos</h3>
          <p>Explora nuestro catálogo y comienza a aprender</p>
          <button class="btn-explore" (click)="router.navigate(['/dashboard/courses'])">
            Explorar Cursos
          </button>
        </div>
      } @else {
        <div class="courses-list">
          @for (course of courses(); track course.id) {
            <article class="course-card">
              <div class="course-image">
                <div class="emoji">{{ course.image }}</div>
                @if (course.es_premium) {
                  <div class="premium-badge">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path d="M7 1L9 5L13 5.5L10 8.5L10.5 12.5L7 10.5L3.5 12.5L4 8.5L1 5.5L5 5L7 1Z" fill="#FFB800" stroke="#FFB800"/>
                    </svg>
                    Premium
                  </div>
                }
              </div>
              
              <div class="course-info">
                <div class="course-header">
                  <h3 class="course-title">{{ course.title }}</h3>
                  <div class="course-progress-badge">
                    {{ course.porcentaje }}%
                  </div>
                </div>
                
                <p class="course-description" [title]="course.description">
                  {{ course.description.length > 200 ? (course.description.substring(0, 200) + '...') : course.description }}
                </p>
                
                <!-- Barra de Progreso -->
                <div class="progress-bar-container">
                  <div class="progress-bar">
                    <div class="progress-fill" [style.width.%]="course.porcentaje"></div>
                  </div>
                  <span class="progress-text">
                    {{ course.clases_completadas }} de {{ course.total_clases }} clases
                  </span>
                </div>
                
                <div class="course-footer">
                  <div class="course-tags">
                    @for (tag of course.tags; track tag) {
                      <span class="tag">{{ tag }}</span>
                    }
                  </div>
                  
                  <div class="course-meta">
                    <span class="start-label">Inicio</span>
                    <span class="start-date">{{ course.startDate }}</span>
                    <button class="btn-view-more" (click)="viewCourse(course.id)">
                      @if (course.porcentaje > 0) {
                        Continuar
                      } @else {
                        Comenzar
                      }
                    </button>
                  </div>
                </div>
              </div>
            </article>
          }
        </div>
      }
    </section>

    <!-- Right Section - Schedule & Calendar -->
    <aside class="schedule-section">
      <!-- Calendar -->
      <div class="calendar-widget">
        <div class="calendar-header">
          <h2 class="calendar-title">{{ currentMonth() }}</h2>
          <div class="calendar-nav">
            <button class="nav-btn">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M12 15L7 10L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
            <button class="nav-btn">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M8 5L13 10L8 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
        </div>
        
        <!-- Debug info - remover después -->
        <div style="padding: 8px; background: rgba(14, 64, 216, 0.1); border: 1px solid rgba(14, 64, 216, 0.3); border-radius: 8px; margin-bottom: 12px;">
          @if (eventosCalendario().length > 0) {
            <div style="color: #0f0; font-size: 11px; font-weight: 500; margin-bottom: 4px;">
              ✅ {{ eventosCalendario().length }} eventos cargados
            </div>
            <div style="color: rgba(255,255,255,0.6); font-size: 10px;">
              Eventos: 
              @for (evt of eventosCalendario(); track evt.id) {
                <div>• {{ evt.titulo }} - {{ evt.fecha_inicio | date:'dd/MM' }}</div>
              }
            </div>
          } @else {
            <div style="color: #f00; font-size: 11px; font-weight: 500;">
              ❌ No hay eventos cargados
            </div>
          }
          <button (click)="loadEventosCalendario()" 
                  style="margin-top: 8px; padding: 4px 8px; background: rgba(14, 64, 216, 0.8); color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 10px; width: 100%;">
            🔄 Recargar eventos
          </button>
        </div>
        
        <div class="calendar-days">
          @for (day of calendarDaysSignal(); track day.fullDate) {
            <div class="day-item" 
                 [class.active]="day.active"
                 [class.has-event]="day.hasEvent"
                 [class.clickable]="day.hasEvent"
                 (click)="day.hasEvent ? onCalendarDayClick(day) : null"
                 [title]="day.hasEvent ? (day.eventos && day.eventos.length > 0 ? day.eventos[0].titulo : 'Evento') : ''">
              <span class="day-name">{{ day.day }}</span>
              <span class="day-number">{{ day.date }}</span>
              @if (day.hasEvent) {
                <span class="event-indicator">
                  <svg width="6" height="6" viewBox="0 0 6 6" fill="none">
                    <circle cx="3" cy="3" r="3" fill="currentColor"/>
                  </svg>
                </span>
              }
            </div>
          }
        </div>
      </div>

      <!-- Schedule -->
      <div class="schedule-widget">
        <div class="schedule-header">
          <h2 class="schedule-title">Próximos Eventos</h2>
          <a href="/dashboard/calendar" class="see-all">Ver Todos</a>
        </div>
        
        <div class="schedule-list">
          @if (schedule().length === 0) {
            <div class="empty-schedule">
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                <circle cx="24" cy="24" r="20" stroke="rgba(255,255,255,0.2)" stroke-width="2"/>
                <path d="M24 16V26L30 30" stroke="rgba(255,255,255,0.5)" stroke-width="2" stroke-linecap="round"/>
              </svg>
              <p>No hay eventos programados</p>
            </div>
          } @else {
            @for (item of schedule(); track item.id) {
              <div class="schedule-item">
                <div class="schedule-date">
                  <span class="date-number">{{ item.date }}</span>
                </div>
                <div class="schedule-details">
                  <h4 class="schedule-event">{{ item.title }}</h4>
                  <p class="schedule-progress">{{ item.progress }}</p>
                </div>
                <div class="schedule-time">
                  <span class="time-text">{{ item.time }}</span>
                </div>
              </div>
            }
          }
        </div>
      </div>
    </aside>
  </div>
</div>

